import { styled } from '@/stitches.config';

import { Box, Input } from '@base-app';
import { ReactComponent as ExitIcon } from '@/assets/icons/exit.svg';
import { ReactComponent as SearchIcon } from '@/assets/icons/search.svg';

export const StyledSearchBoxContainer = styled(Box, {
  display: 'flex',
  alignItems: 'baseline',
  height: '$10',
});

export const StyledInputContainer = styled(Box, {
  display: 'inline-block',
  position: 'relative',
});

export const StyledInput = styled(Input, {
  padding: '$2 $5',
  borderRadius: '$3',
  border: '$borderWidths$1 solid $colors$darkGray700',
  '& input': {
    lineHeight: '$6',
    border: '$0',
    borderBottom: 'none',
  },
  '& input:focus': {
    border: '$0',
    borderBottom: 'none',
  },
  '& input:hover': {
    border: '$0',
    borderBottom: 'none',
  },
});

export const StyledSearchIcon = styled(SearchIcon, {
  cursor: 'pointer',
  height: '100%',
});

export const StyledExitIcon = styled(ExitIcon, {
  cursor: 'pointer',
  height: '$5',
  position: 'absolute',
  right: '$4',
  top: '$3',
  width: '$5',
});
